import produce from 'immer';
import {
  GAME_CONFIG_INFO_LIST_REQUEST,
  CREATE_GAME_CONFIG,
  REMOVE_GAME_CONFIG,
  UPDATE_GAME_CONFIG,
} from '../../constants/app/fixAppDataConstants';

const initialState = {

};

const fixAppDataReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case GAME_CONFIG_INFO_LIST_REQUEST:
    case CREATE_GAME_CONFIG:
    case REMOVE_GAME_CONFIG:
    case UPDATE_GAME_CONFIG:
      break;
    default:
      break;
  }
});

export default fixAppDataReducer;
